import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChatLoadMessageService {
  private chatLoadingMessageSubject = new BehaviorSubject<string>('');

  chatLoadingMessage$ = this.chatLoadingMessageSubject.asObservable();

  get chatLoadingMessage(): string {
    return this.chatLoadingMessageSubject.value;
  }

  setLoadingMessage(message: string): void {
    this.chatLoadingMessageSubject.next(message);
  }
}
